const style = {
  navbar:
    'h-[60px] w-full z-50 top-0 fixed px-10 flex items-center text-[#e3e4e8] gruppo font-bold',
  links: 'hidden ml-auto md:flex space-x-1 mr-10',
  links_mobile: 'md:hidden ml-auto',
  icon: 'h-9 w-9 hover:cursor-pointer p-2',
  link: 'cursor-none hover:cursor-pointer hover:bg-black hover:transition hover:duration-300 px-2 md:px-4 py-2 rounded-md',
  logo: 'ml-0 md:ml-10',
};

export default style;
